import React from 'react'

const LogoPurplecon = (
  <>
    <path
      d="M6.53467 6.65485C6.53467 7.05723 6.55037 7.45171 6.57392 7.83831C7.14093 8.18155 7.63667 8.63161 8.03391 9.16377C10.5771 12.4617 11.5976 18.5998 11.5976 18.5998C11.5976 18.5998 15.224 11.8147 15.224 6.65485C15.224 -0.224944 6.53467 -0.477415 6.53467 6.65485Z"
      fill="#B8A6C9"
    />
    <path
      d="M6.57396 7.83839C3.29289 5.89753 -0.553338 9.54256 2.4844 13.4874C6.17364 18.2764 11.5976 18.5999 11.5976 18.5999C11.5976 18.5999 7.06847 14.6235 6.57396 7.83839Z"
      fill="#B8A6C9"
    />
    <path
      d="M18.293 14.4815C17.8397 14.9622 17.293 15.344 16.6867 15.6033C16.0803 15.8625 15.4275 15.9936 14.7686 15.9884C14.7275 15.3266 14.8227 14.6634 15.0483 14.0402C15.2738 13.4171 15.6248 12.8474 16.0794 12.3668C16.5339 11.8862 17.0823 11.5051 17.69 11.2472C18.2978 10.9893 18.952 10.8602 19.6117 10.868C19.6497 11.529 19.5522 12.1907 19.3254 12.8123C19.0985 13.4338 18.7471 14.002 18.293 14.4815Z"
      fill="#B8A6C9"
    />
  </>
)

export default LogoPurplecon
